import { fabricErrors, filterFabricErrors, isFabricError } from './errors.js';

export const errors = {
  fabricErrors,
  isFabricError,
  filterFabricErrors,
};
